import { Component, OnInit} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AssetTransferService } from '../../services/asset-transfer.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { Location } from '@angular/common'; 
import { AssetTransfer } from '../../models/entities/asset-transfer';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { PartnerLovComponent } from 'src/app/assabil-admin/components/master-data/partner/partner-lov/partner-lov.component';
import { AssetTransferType } from '../../enums/asset-transfer-type';
import { AssetTransferDirection } from '../../enums/asset-transfer-direction';


@Component({
    selector: 'asset-transfer-list-mobile',
    templateUrl: './asset-transfer-list-mobile.component.html',
    styleUrls: ['./asset-transfer-list-mobile.component.scss']
})

export class AssetTransferListMobileComponent implements OnInit {

  assetTransfers      : AssetTransfer[]= []; 
  assetOrderCode      : string;
  newAssetTransfer    : AssetTransfer;
  direction           : string = undefined;
  assetTransferType   : string = undefined;

  selectedRow         : AssetTransfer = null;
  listFields          = [];
  formFields          = [];
  title              : string = "Transferts"

  constructor(
    protected assetTransferService  : AssetTransferService,
    protected toastr                 : ToastrService,
    protected router                 : Router,
    protected baseService            : BaseService,
    protected leanUtilsService       : LeanUtilsService,
    protected location               : Location,
    protected activatedRoute         : ActivatedRoute) {

 //     this.direction          = this.activatedRoute.snapshot.data['direction'];
 //     this.assetTransferType  = this.activatedRoute.snapshot.data['assetTransferType'];
  }

  ngOnInit(){

   this.listFields  = [  
    { prop: 'assetTransferCode',     name: 'N° Transfert' },
    { prop: 'theDate',               name: 'Date',                   type: 'date' },
    { prop: 'expeditionForecastDate',name: 'Prévu',                   type: 'date' },
  ]

  this.formFields = [  
    { prop: 'assetTransferCode',      name: 'N° Transfert'                  },
    { prop: 'theDate',                name: 'Date',            type: 'date' },
    { prop: 'expeditionForecastDate', name: 'Prévu',           type: 'date' },
    { prop: 'progressLevel',          name: 'Stade'                         },
    { prop: 'fromBranch',             name: 'Expéditeur'                    },
    { prop: 'toBranch',               name: 'Destinataire'                  },
    { prop: 'partner',                name: 'Client',           modal : PartnerLovComponent, subProp : 'name'   },
  ]
    
  
  // If we come here from asset-order-widget-mobile :     this.router.navigate(['/dashboard/services/asset-transfer-list-mobile', {assetOrderCode : this.assetOrder.assetOrderCode, direction : 'toMyBranch'}]);
  //  => parameters will be located in this.activatedRoute.data otherwise they will located in   this.activatedRoute.params
  this.activatedRoute.data.subscribe(data => {

      this.assetOrderCode     = data['assetOrderCode'];
      this.direction          = data['direction'];
      this.assetTransferType  = data['assetTransferType'];


      if ( (! this.assetOrderCode) && (!this.direction)  && (!this.assetTransferType)  ) {
        this.activatedRoute.params.subscribe(params => {
          this.assetOrderCode     = params['assetOrderCode'];
          this.direction          = params['direction'];
          this.assetTransferType  = params['assetTransferType'];
      });
      }
      
  });


  let sourceBranchCode      : string = null;
  let destinationBranchCode : string = null;
  let partnerCode           : string = null;
  let plInitial             : boolean = false;
  let plSent                : boolean = false;
  let plSemiReceived        : boolean = false;
  let plReceived            : boolean = false;

  if (this.assetTransferType  ==  AssetTransferType.Reception){
    destinationBranchCode   = ".";
    plInitial               = true;
    plReceived              = true;
    this.title              = "Réceptions";
  }

  if (this.assetTransferType  ==  AssetTransferType.Assignment){
    sourceBranchCode        = ".";                // means my own branch
    plInitial               = true;
    if (this.direction == AssetTransferDirection.output){
      this.title              = "Affectations Client";
    } else {
      this.title              = "Retours Client";
    }
  }


  if (this.assetTransferType  ==  AssetTransferType.Transfer){
    if (this.direction == AssetTransferDirection.output){
      sourceBranchCode        = ".";                // means my own branch
      plInitial               = true;
      this.title              = "Expéditions Agence";
    } else {
      destinationBranchCode   = ".";            // means my own branch
      plSent                  = true;
      this.title              = "Réceptions Agence";
    }
  }



  this.assetTransferService.assetTransfersGet(
    this.assetOrderCode     ,
    sourceBranchCode        , 
    destinationBranchCode   ,
    partnerCode             , 
    this.assetTransferType  , 
    plInitial               , 
    plSent                  , 
    plSemiReceived          ,
    plReceived              ,
    null                    , 
    null                   ).then(result => {
    this.assetTransfers = result;
  })

  }

  returnBack(){
    this.location.back();
  }
}
